var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 24,
    viewBox: "0 0 90 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10_252",
    transform: "translate(0 -0.01) scale(0.008 0.03)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_10_252",
    width: 125,
    height: 34,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAAAiCAYAAAByWNYHAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAB3RJTUUH4gcKDw86AA2uHQAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAMaSURBVHja7ZzLaxRBEMZ/q2uicWNWxUdAISwGQyKKESXGF1EPirooBPEgGsSbgjf/Bi/iQRAkQaNeRA+ixgfqIQE1F8WTisEXEUxABNfgmkTceJgOBMlMzezOc6c/GBa6qnv6m2+mpqqn2QTb29GIF2boSwDAhMXxQ4uuoUXX0KJraNE1tOgaWnSNYJBUvxkLnwLw2eSGqXNhDiPqGPWIYw0wF5jt43WtAKrVuf9HHhguctx5isucEub2cVL0DxZOOSA9TXu10M8JCsAg0AtcBx6pGtlp1GoDskALUA/M91HoLcARYJt6iGaa+N0D9gpjJYCtwIEpXBa4NM9EMkSvmTqgQx3PgaPAe5v9NwEXgNUBzH0pcBnY5dJ4rcB5oDlu7/RW4BmwwoZvB9AXkOCLgH4XBT+sol2z109YWLEYuKZCnRnagC6LUOo1LrqU10ze6N3ArLhn7y3AZgv7mQAFzwD7XRzvrF9colCymYXOJmBDwPNKuDRWo7rBfS3ZvEBevW+nQxpIATuAPcI4a0zad9uYw0ugB/gK/ALGTfxuFMFvlQ2fPpWt5zC+1k0AQyaZv4RXwB3FJQ+Mmfh1A1VBif4HuCn4nAM6geMWPkuKvOj3Vfn21yN+tYK9R53fTunZINh7gZ02uXRGIbxfEewLTdqXC/0ueSg4Nurmqw7WGjKCvctNLmEQ/YtgN0tupIWXgYDzoSEHY/nKJQyi5wW72ZJjpdAv5/G8awT7iIOxfOUSBtHHBXuFSXsq5FVHwYGvtJY+Wm6il5IoasRM9HwZ6SA9yVVadAO/S8yuw4QxwZ7Wohv4LtgbI8Tlm2Bv0qIb+CTYT7odFgPkcsLNxDUZYdFfC/aNwDuMDRnDwM8Qc3kj2NeqWv2BDS6V5Sz6Exs+y4BjEeDy2IZPrVtcohzeB4CnZZK9D2LsFtIlmw2cRl7ciQpO+cUl6qL3A4dslG9RwAvgIMYnYC26gFvAOuAhznfQhg23MfbH3cXZMm5ssvepeIuxqaIe2AesB1Zi7FRNYWzXjlKuksX43JpVXBpUIucKl4T+U4L44R/S2YSMqkLNlwAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a2290a931be0e3a8f3e7499cb103c7ab.svg";
export { ForwardRef as ReactComponent };